import { ERoomsTotal } from '../../../../../../../packages/api-models/common/json_query';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectFlatRoomsFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const FlatRoomsContainer: FC = () => {
  const { label, value, options } = useSelector(selectFlatRoomsFilter);

  const onChange = useFilterChangeCallback();

  const handleFlatRoomsChange = useCallback(
    (newValue: NonEmptyArray<ERoomsTotal> | null) => {
      onChange({ action: 'setRoomsCount', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleFlatRoomsChange} />
    </AdvancedFilterRow>
  );
};
